<template>
  <swiper
    :id="sliderRef + '-image-slider'"
    class="image-slider"
    :options="swiperOptions"
    :ref="sliderRef"
  >
    <swiper-slide
      v-for="(image, index) in images"
      v-bind:key="sliderRef + '-slide-' + index"
    >
      <artwork-card
        :thumbnail="image.image_url"
        :artworkId="image.id"
        :username="image.username"
        :proFile="image.pro_file"
        :showPlayIcon="image.type === 'animation'"
        :isVerified="image.artist_verified"
        size="xs"
      />
    </swiper-slide>
    <div v-if="images.length > 4" class="slider-button-prev" slot="button-prev">
      <i class="fas fa-chevron-left"></i>
    </div>
    <div v-if="images.length > 4" class="slider-button-next" slot="button-next">
      <i class="fas fa-chevron-right"></i>
    </div>
  </swiper>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { ArtworkCard } from "../components";

export default {
  name: "image-slider",
  data() {
    return {
      swiperOptions: {
        slidesPerView: 4,
        spaceBetween: 30,
        navigation: {
          nextEl: ".slider-button-next",
          prevEl: ".slider-button-prev",
        },
        breakpoints: {
          576: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
        },
      },
    };
  },
  components: {
    swiper,
    swiperSlide,
    ArtworkCard,
  },
  props: {
    images: {
      type: Array,
      default: () => [],
      description: "Images to display in the slider",
    },
    sliderRef: {
      type: String,
      description: "Ref to differentiate the sliders",
    },
  },
};
</script>

<style lang="scss">
.image-slider {
  .slider-button-next,
  .slider-button-prev {
    position: absolute;
    top: 50%;
    margin-top: -38px;
    z-index: 10;
    cursor: pointer;
    font-size: 2rem;
    color: white;
  }

  .slider-button-next {
    left: auto;
    right: 10px;
  }

  .slider-button-prev {
    left: 10px;
    right: auto;
  }

  .swiper-wrapper {
    .card-wrapper {
      margin-bottom: 0;

      .card,
      .artwork-card-footer {
        margin-bottom: 0;
      }
    }
  }
}

@media (max-width: 575.98px) {
  .image-slider {
    .slider-button-next,
    .slider-button-prev {
      display: none;
    }
  }
}
</style>
